import { type CustomProperties, init, track } from "@plausible-analytics/tracker";
import { useEffect, useRef } from "react";
import Settings from "@/Settings";

//let plausibleInitialized = false; // Prevents init being loaded multiple times in strict mode

declare global {
  interface Window {
    __plausibleInitialized?: boolean; // To prevent init being loaded multiple timed during hot reload
  }
}

export const usePlausibleTrackingInit = () => {
  useEffect(() => {
    if (!window.__plausibleInitialized) {
      if (Settings.PAGE_DOMAIN) {
        init({
          domain: Settings.PAGE_DOMAIN,
          captureOnLocalhost: Settings.PAGE_DOMAIN.startsWith("dev"),
          autoCapturePageviews: false,
        });
        console.log(`Plausible tracking init: ${Settings.PAGE_DOMAIN}`);
      } else {
        console.log("Plausible tracking is not configured.");
      }
      window.__plausibleInitialized = true;
    }
  });
};

interface usePlausibleTrackingPageViewProps {
  documentId?: number;
  instanceSlug?: string;
  isModalDocumentEditor?: boolean;
  mediaId?: string;
  isModalMediaEditor?: boolean;
  mediaType?: string;
  ownerSlug?: string;
  schemaId?: string;
  selectedLocale?: string;
  viewType?: "dashboard" | "documentList" | "mediaList" | "QRCodeList" | "documentEditor" | "mediaEditor";
}

export const usePlausibleTrackingPageView = (props: usePlausibleTrackingPageViewProps) => {
  const hasTracked = useRef({
    mediaType: null,
    schemaId: null,
  });
  const toCustomProperties = (props: usePlausibleTrackingPageViewProps): CustomProperties => {
    const cleanedProps: CustomProperties = {};
    if (!props) {
      return cleanedProps;
    }
    Object.entries(props).forEach(([key, value]) => {
      if (value !== undefined) {
        cleanedProps[key] = value.toString();
      }
    });
    return cleanedProps;
  };

  const customProperties = toCustomProperties(props);

  useEffect(() => {
    if (hasTracked.current.mediaType !== props?.mediaType || hasTracked.current.schemaId !== props?.schemaId) {
      track("pageview", { props: customProperties });

      hasTracked.current = {
        mediaType: props?.mediaType,
        schemaId: props?.schemaId,
      };
    }
  }, [props?.schemaId, props?.mediaType]);
};

export const plausibleTrackQRCodeLogoToggle = (withLogo: boolean) => {
  // @ts-ignore
  track("QRCodeLogoToggle", { props: { logo: withLogo.toString() } });
};

export const plausibleTrackAiButtonClicked = (aiFunctionType: string, ownerSlug: string, ownerId: number | string) => {
  // @ts-ignore
  track("AiButtonClicked", { props: { aiFunctionType: aiFunctionType, ownerSlug: ownerSlug, ownerId: ownerId } });
};

export const plausibleTrackPCSRemoteControlTaskSent = (remoteControlCommand: string) => {
  // @ts-ignore
  track("PCSRemoteControlTaskSent", { props: { remoteControlCommand: remoteControlCommand } });
};
